import { useState, useEffect } from 'react';
import api from '../../utils/api';

const API_BASE = 'https://ems.ourschool.lk';

const JOB_LABELS = {
  Manager:         'Manager',
  Cashier:         'Cashier',
  ComputerOperator: 'Computer Operator',
  CashierAndOperator: 'Cashier and Operator',
  Labors:          'Labors',
  FamilyRepresentative: 'Family Representative',
};

const SECTION_TABS = [
  { key: 'personal',  label: 'Personal'  },
  { key: 'other',     label: 'Other'     },
  { key: 'family',    label: 'Family'    },
  { key: 'education', label: 'Education' },
  { key: 'contact',   label: 'Contact'   },
  { key: 'employee',  label: 'Employee'  },
  { key: 'vehicles',  label: 'Vehicles'  },
];

function Field({ label, value, wide }) {
  return (
    <div style={{ gridColumn: wide ? '1 / -1' : undefined }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 3 }}>
        {label}
      </div>
      <div style={{
        fontSize: 13, color: value ? 'var(--text)' : 'var(--text3)',
        background: 'var(--surface2)', border: '1px solid var(--border)',
        borderRadius: 6, padding: '7px 10px', minHeight: 34,
        fontStyle: value ? 'normal' : 'italic',
      }}>
        {value || '—'}
      </div>
    </div>
  );
}

function SectionHeader({ title }) {
  return (
    <div style={{
      fontSize: 11, fontWeight: 700, color: 'var(--primary)',
      textTransform: 'uppercase', letterSpacing: '.08em',
      borderBottom: '2px solid var(--primary-l)', paddingBottom: 6,
      marginBottom: 4, gridColumn: '1 / -1',
    }}>
      {title}
    </div>
  );
}

/* ── Tab contents ─────────────────────────────────────────────────────────── */

function PersonalTab({ m }) {
  const imgSrc = m?.owner_image_path ? `${API_BASE}/uploads/${m.owner_image_path}` : null;
  const sigSrc = m?.signature_path   ? `${API_BASE}/uploads/${m.signature_path}`   : null;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
      <Field label="Member No"   value={m?.member_no}   />
      <Field label="Market Name" value={m?.market_name} />
      <Field label="Name"        value={m?.name}        />
      <Field label="Tax File No" value={m?.tax_file_no} />
      <Field label="BR No"       value={m?.br_no}       />
      <Field label="BTT No"      value={m?.btt_no}      />
      <Field label="Bond No"     value={m?.bond_no}     />
      <Field label="EPF No"      value={m?.epf_no}      />
      <Field label="ETF No"      value={m?.etf_no}      />
      {/* Images */}
      <div style={{ gridColumn: '1 / -1', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 4 }}>
        {/* <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 6 }}>Owner Image</div>
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--surface2)' }}>
            {imgSrc
              ? <img src={imgSrc} alt="Owner" style={{ maxHeight: 138, maxWidth: '100%', objectFit: 'contain' }} />
              : <span style={{ color: 'var(--text3)', fontSize: 12, fontStyle: 'italic' }}>No image</span>
            }
          </div>
        </div> */}
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 6 }}>Owner Image</div>
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--surface2)' }}>
            {sigSrc
              ? <img src={sigSrc} alt="Signature" style={{ maxHeight: 138, maxWidth: '100%', objectFit: 'contain' }} />
              : <span style={{ color: 'var(--text3)', fontSize: 12, fontStyle: 'italic' }}>No signature</span>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

function OtherTab({ m }) {
  const capitalize = v => v ? v.charAt(0).toUpperCase() + v.slice(1) : '';
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
      <Field label="Address 1"      value={m?.address1}   wide />
      <Field label="Address 2"      value={m?.address2}   wide />
      <Field label="Birth Date"     value={m?.birth_date ? m.birth_date.split('T')[0] : ''} />
      <Field label="Marital Status" value={capitalize(m?.married)} />
      <Field label="Sex"            value={capitalize(m?.sex)} />
      <Field label="Religion"       value={m?.religion} />
      <Field label="ID Card No"     value={m?.id_card_no} />
      <Field label="Other Name"     value={m?.other_name} />
    </div>
  );
}

function FamilyTab({ rows }) {
  if (!rows.length) return <p style={{ color: 'var(--text3)', fontStyle: 'italic', padding: '24px 0', textAlign: 'center' }}>No family members recorded.</p>;
  return (
    <div style={{ overflowX: 'auto' }}>
      <table>
        <thead>
          <tr>
            <th>Relationship</th>
            <th>Name</th>
            <th>Sex</th>
            <th>Birth Date</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td><span className="badge badge-blue" style={{ textTransform: 'capitalize' }}>{r.relationship}</span></td>
              <td>{r.name}</td>
              <td style={{ textTransform: 'capitalize' }}>{r.sex || '—'}</td>
              <td>{r.birth_date ? r.birth_date.split('T')[0] : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function EducationTab({ m }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <Field label="Educational Qualification" value={m?.educational_qualification} wide />
      <Field label="Other Qualifications"      value={m?.other_qualifications}      wide />
    </div>
  );
}

function ContactTab({ m }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
      <SectionHeader title="Member Contact" />
      <Field label="Hand Phone"       value={m?.member_handphone} />
      <Field label="Resident Land Phone" value={m?.member_resident_landphone} />
      <Field label="Email"            value={m?.member_email} />
      <SectionHeader title="Market Contact" />
      <Field label="Market Hand Phone" value={m?.market_handphone} />
      <Field label="Market Land Phone" value={m?.market_landphone} />
      <Field label="Market Fax"        value={m?.market_fax} />
    </div>
  );
}

function EmployeeTab({ rows }) {
  if (!rows.length) return <p style={{ color: 'var(--text3)', fontStyle: 'italic', padding: '24px 0', textAlign: 'center' }}>No employees recorded.</p>;
  return (
    <div style={{ overflowX: 'auto' }}>
      <table>
        <thead>
          <tr>
            <th>Job Type</th>
            <th>Name</th>
            <th>Phone</th>
            <th>ID No</th>
            <th>Sex</th>
            <th>Birth Date</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td><span className="badge badge-blue">{JOB_LABELS[r.job_type] || r.job_type}</span></td>
              <td>{r.name}</td>
              <td>{r.phone || '—'}</td>
              <td>{r.id_no || '—'}</td>
              <td style={{ textTransform: 'capitalize' }}>{r.sex || '—'}</td>
              <td>{r.birth_date ? r.birth_date.split('T')[0] : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function VehiclesTab({ rows }) {
  if (!rows.length) return <p style={{ color: 'var(--text3)', fontStyle: 'italic', padding: '24px 0', textAlign: 'center' }}>No vehicles recorded.</p>;
  return (
    <div style={{ overflowX: 'auto' }}>
      <table>
        <thead>
          <tr>
            <th>Type</th>
            <th>Number</th>
            <th>Owner</th>
            <th>Vehicle Reg</th>
            <th>Driver</th>
            <th>Driver ID</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td><span className="badge badge-yellow" style={{ textTransform: 'capitalize' }}>{r.type}</span></td>
              <td>{r.number || '—'}</td>
              <td>{r.owner || '—'}</td>
              <td>{r.vehicle_reg || '—'}</td>
              <td>{r.driver || '—'}</td>
              <td>{r.driver_id_no || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* ── Main modal component ─────────────────────────────────────────────────── */

export default function ShopDetailModal({ shop, onClose, onEdit }) {
  const [activeTab, setActiveTab] = useState('personal');
  const [loading, setLoading]     = useState(true);
  const [member, setMember]       = useState(null);
  const [family, setFamily]       = useState([]);
  const [employees, setEmployees] = useState([]);
  const [vehicles, setVehicles]   = useState([]);

  useEffect(() => {
    if (!shop?.id) return;
    setLoading(true);

    api.get(`/members/shop/${shop.id}`)
      .then(async ({ data: m }) => {
        setMember(m);
        if (m?.id) {
          const [fam, emp, veh] = await Promise.all([
            api.get(`/family/${m.id}`).then(r => r.data).catch(() => []),
            api.get(`/employees/${m.id}`).then(r => r.data).catch(() => []),
            api.get(`/vehicles/${m.id}`).then(r => r.data).catch(() => []),
          ]);
          setFamily(fam);
          setEmployees(emp);
          setVehicles(veh);
        }
      })
      .catch(() => setMember(null))
      .finally(() => setLoading(false));
  }, [shop?.id]);

  // Close on backdrop click
  const onBackdrop = e => { if (e.target === e.currentTarget) onClose(); };

  const hasData = !!member;

  return (
    <div
      onClick={onBackdrop}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 24,
      }}
    >
      <div style={{
        background: 'var(--surface)',
        borderRadius: 16,
        boxShadow: '0 24px 60px rgba(0,0,0,.22)',
        width: '100%', maxWidth: 820,
        maxHeight: '90vh',
        display: 'flex', flexDirection: 'column',
        overflow: 'hidden',
      }}>
        {/* ── Header ── */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '18px 24px',
          borderBottom: '1px solid var(--border)',
          background: 'var(--surface)',
          flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 40, height: 40, borderRadius: 10,
              background: 'var(--primary-l)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="20" height="20" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700 }}>{shop.shop_code}</div>
              {member?.name && <div style={{ fontSize: 12, color: 'var(--text3)' }}>{member.name}{member.member_no ? ` · Member #${member.member_no}` : ''}</div>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary btn-sm" onClick={() => onEdit(shop)}>
              <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a1 1 0 00-1 1v9a1 1 0 001 1h9a1 1 0 001-1v-7"/><path d="M9 1l3 3-7 7H2v-3L9 1z"/></svg>
              Edit
            </button>
            <button className="btn btn-secondary btn-sm" onClick={onClose}>✕ Close</button>
          </div>
        </div>

        {/* ── Section tabs ── */}
        <div style={{
          display: 'flex', gap: 2, padding: '10px 24px 0',
          borderBottom: '1px solid var(--border)',
          background: 'var(--surface2)', flexShrink: 0, overflowX: 'auto',
        }}>
          {SECTION_TABS.map(t => (
            <button
              key={t.key}
              onClick={() => setActiveTab(t.key)}
              style={{
                padding: '7px 14px', border: 'none', cursor: 'pointer',
                background: 'none', fontFamily: 'inherit', fontSize: 13,
                fontWeight: activeTab === t.key ? 600 : 400,
                color: activeTab === t.key ? 'var(--primary)' : 'var(--text2)',
                borderBottom: activeTab === t.key ? '2px solid var(--primary)' : '2px solid transparent',
                marginBottom: -1, whiteSpace: 'nowrap',
                transition: 'color .15s',
              }}
            >
              {t.label}
              {t.key === 'family'   && family.length    > 0 && <span className="badge badge-blue"   style={{ marginLeft: 6, padding: '1px 6px', fontSize: 10 }}>{family.length}</span>}
              {t.key === 'employee' && employees.length > 0 && <span className="badge badge-green"  style={{ marginLeft: 6, padding: '1px 6px', fontSize: 10 }}>{employees.length}</span>}
              {t.key === 'vehicles' && vehicles.length  > 0 && <span className="badge badge-yellow" style={{ marginLeft: 6, padding: '1px 6px', fontSize: 10 }}>{vehicles.length}</span>}
            </button>
          ))}
        </div>

        {/* ── Content ── */}
        <div style={{ flex: 1, overflowY: 'auto', padding: 24 }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '48px 0', color: 'var(--text3)' }}>
              <div style={{ fontSize: 14 }}>Loading details…</div>
            </div>
          ) : !hasData ? (
            <div style={{ textAlign: 'center', padding: '48px 0' }}>
              <svg width="48" height="48" fill="none" stroke="#d1d5db" strokeWidth="1.5" style={{ margin: '0 auto 12px', display: 'block' }}>
                <circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/>
              </svg>
              <p style={{ color: 'var(--text3)', fontSize: 14, marginBottom: 12 }}>No data recorded for this shop yet.</p>
              <button className="btn btn-primary" onClick={() => onEdit(shop)}>Add Details</button>
            </div>
          ) : (
            <>
              {activeTab === 'personal'  && <PersonalTab  m={member} />}
              {activeTab === 'other'     && <OtherTab     m={member} />}
              {activeTab === 'family'    && <FamilyTab    rows={family} />}
              {activeTab === 'education' && <EducationTab m={member} />}
              {activeTab === 'contact'   && <ContactTab   m={member} />}
              {activeTab === 'employee'  && <EmployeeTab  rows={employees} />}
              {activeTab === 'vehicles'  && <VehiclesTab  rows={vehicles} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
